import Icons from '@hedepy/icons/legacy'
import React from 'react'

import { cn } from '@/legacy-src/lib/utils'

import { LazyIcon, type LazyIconProps } from '@/src/domains/design-system/components/LazyIcon'

import { type IconBaseType } from '../../types/ComponentTypes'
import { textToCamelCase } from '../../utilities/textUtilities'

/**
 * @deprecated
 */
export type IconPropsType = Omit<IconBaseType, 'size' | 'icon'> & {
  className?: string
  width?: number
  height?: number
  size?: IconBaseType['size'] | number
  icon?: LazyIconProps['name'] | (string & {})
}

const isLazyIcon = (icon: string): icon is LazyIconProps['name'] => {
  return icon.endsWith('-icon')
}

/**
 * @deprecated
 */
const Icon: React.FC<IconPropsType> = ({ className = '', color = null, icon, size = 'sm', name, ...props }) => {
  const nameCamelCase = `Symbolic${textToCamelCase(icon || '')}`

  if (!icon) {
    return null
  }

  const isNumericSize = typeof size === 'number'

  if (isLazyIcon(icon)) {
    return (
      <LazyIcon
        name={icon}
        size={isNumericSize ? size : 'auto'}
        className={cn('icon', `icon--${isNumericSize ? 'native' : size}`, color && `text-${color}`, className)}
      />
    )
  }

  const Svg = Icons[nameCamelCase]

  if (!Icons || !Svg) {
    return null
  }

  return (
    <Svg
      {...props}
      name={name}
      width={isNumericSize ? size : (props.width ?? undefined)}
      height={isNumericSize ? size : (props.height ?? undefined)}
      className={cn('icon', `icon--${isNumericSize ? 'native' : size}`, color && `text-${color}`, className)}
    />
  )
}

export default Icon
